import { createAction } from '@ngrx/store';

import { ClientBrokersActionTypes } from './types';

// Client Brokers
export const init = createAction(ClientBrokersActionTypes.Init);

export const destroyed = createAction(ClientBrokersActionTypes.Destroyed);
